import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";

export function useCarrierAccountsForAutomation() {
  const merchantRpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  const carrierAccountsLoad = useLoad(
    async (signal: AbortSignal) => {
      const [carrierAccounts, amazonIntegration] = await Promise.all([
        merchantRpcClient.getCarrierAccounts(null, { signal }),
        merchantRpcClient.getAmazonIntegration({}, { signal }),
      ]);

      return [
        ...carrierAccounts.merchantCarrierAccounts,
        ...(amazonIntegration.buyShippingCarrierAccount
          ? [amazonIntegration.buyShippingCarrierAccount]
          : []),
      ];
    },
    [merchantRpcClient],
  );

  const carrierAccounts = carrierAccountsLoad.value ?? [];

  return {
    carrierAccounts,
    carrierAccountsLoading: carrierAccountsLoad.pending,
  };
}
